export default __webpack_public_path__ + "static/media/lieferheld_background_s1.ba670914.jpg";